import React, { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';
import { Icon } from 'components/Atoms/Icon/Icon';
import styles from './SearchBar.module.scss';

interface SearchBarProps {
  debounceTime?: number;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
}

export function SearchBar(props: SearchBarProps) {
  const { placeholder, value, onChange, debounceTime = 0, className } = props;
  const [searchValue, setSearchValue] = useState(value);

  // Create the debounced function only once and memoize it
  const debouncedOnChange = useMemo(
    () => debounce((newValue: string) => onChange?.(newValue), debounceTime),
    [onChange, debounceTime],
  );

  // Cleanup: cancel pending debounced calls on unmount
  useEffect(() => () => debouncedOnChange.cancel(), [debouncedOnChange]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setSearchValue(newValue);
    debouncedOnChange(newValue);
  };

  return (
    <div className={[styles.searchBarContainer, className].join(' ')}>
      <Icon name="searchGlass" width={20} height={20} classname={styles.searchIcon} />
      <input
        type="text"
        className={styles.searchInput}
        aria-label={placeholder}
        placeholder={placeholder}
        value={searchValue}
        onChange={handleChange}
      />
    </div>
  );
}
